import axios from './axios';

type Response = {
  success: boolean;
};

export const validateToken = async () => {
  const response = await axios.get<Response>('/auth/validate_token');

  return response.data.success;
};
